import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ONBOARDING_EXPERIENCES } from '../../constants/onboarding-state/onboarding-constants.ts';
import { HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-home-takeover-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadHomeOnboardingTakeoverV2 = (): Promise<{
	data: onboardingStateGetOnboardingStateQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [
				ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN,
				...Object.values(HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS),
			],
		},
	});
};
